import { render } from "./Contact_page_m.vue?vue&type=template&id=bcdc8966&scoped=true"
import script from "./Contact_page_m.vue?vue&type=script&lang=js"
export * from "./Contact_page_m.vue?vue&type=script&lang=js"

import "./Contact_page_m.vue?vue&type=style&index=0&id=bcdc8966&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-bcdc8966"

export default script